import moment from 'moment'

import { DATE_FORMAT, DATE_INPUT_FORMAT } from './format'

export function formatDateInput(input: string) {
  const dateMoment = moment(input, DATE_INPUT_FORMAT, true)

  return dateMoment.isValid() ? dateMoment.format(DATE_FORMAT) : null
}

export function formatDateAsInput(date: string) {
  const dateMoment = moment(date, DATE_FORMAT, true)

  return dateMoment.isValid() ? dateMoment.format(DATE_INPUT_FORMAT) : null
}

export function dateInputIsValid(input: string) {
  return !input || moment(input, DATE_INPUT_FORMAT, true).isValid()
}
